export default __webpack_public_path__ + "static/media/video.9e986439.mp4";